import React, { useState, useRef, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import CustomPhoneInput from '../PhoneInput';

const EditCustomerPopup = ({ customer, onClose, onSuccess }) => {
    const [editCustomer, setEditCustomer] = useState({ ...customer });
    const popupRef = useRef(null);
  
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) onClose();
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose]);
  
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setEditCustomer(prev => ({ ...prev, [name]: value }));
    };
  
    const handlePhoneChange = (phone) => {
      setEditCustomer(prev => ({ ...prev, mobileNumber: phone }));
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_API}/api/updateUser/${editCustomer._id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(editCustomer)
        });
        if (response.ok) {
          const data = await response.json();
          onSuccess(data.user);
        } else {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Unknown error');
        }
      } catch (error) {
        console.error('Error updating customer:', error);
      }
    };
  
    return (
      <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
        <div ref={popupRef} className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md relative">
          <button onClick={onClose} className="absolute top-2 right-2 text-gray-600 hover:text-gray-800">
            <FaTimes size={20} />
          </button>
          <h3 className="text-xl font-bold mb-4">Edit Client</h3>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <input type="email" name="email" value={editCustomer.email} onChange={handleInputChange} placeholder="Email" className="w-full p-2 border rounded" required />
            </div>
            <div className="mb-4">
              <input type="text" name="name" value={editCustomer.name} onChange={handleInputChange} placeholder="Name" className="w-full p-2 border rounded" required />
            </div>
            <div className="mb-4">
              <select name="role" value={editCustomer.role} onChange={handleInputChange} className="w-full p-2 border rounded" disabled>
                <option value="user">User</option>
              </select>
            </div>
            <div className="mb-4">
              <CustomPhoneInput value={editCustomer.mobileNumber} onChange={handlePhoneChange} />
            </div>
            <div className="mb-4">
              <input type="text" name="location" value={editCustomer.location} onChange={handleInputChange} placeholder="Location" className="w-full p-2 border rounded" />
            </div>
            <div className="mb-4">
              <textarea name="description" value={editCustomer.description || ''} onChange={handleInputChange} placeholder="Description" className="w-full p-2 border rounded" />
            </div>
            <div className="flex justify-end space-x-2">
              <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400">Cancel</button>
              <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700">Save</button>
            </div>
          </form>
        </div>
      </div>
    );
  };
  
  export default EditCustomerPopup;